import cn from 'classnames';
import { Counter } from 'components/counter';
import { FC, HTMLAttributes, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { twMerge } from 'tailwind-merge';

const cardWrapperClassName = 'bg-other-white rounded-md p-3';
const cardTitleClassName = 'text-text-light-bg-primary font-black text-sm leading-4';

interface Description {
  content: string;
  id: string;
}

export type TinyCartItemProps = {
  title: string;
  image: ReactNode;
  price: ReactNode;
  description: Description[];
  footerMessage?: string;
  quantity?: number;
  truncateTitle?: boolean;
} & HTMLAttributes<HTMLDivElement>;

/**
 * Used to display cart item inside of the tiny cart
 * Temporary being used in checkout summary
 * TODO: make ui part abstract, reusable and separate from the usage of the context
 */
const TinyCartItem: FC<TinyCartItemProps> = ({
  title,
  image,
  price,
  className,
  quantity,
  description,
  footerMessage,
  truncateTitle = false,
  ...props
}) => {
  return (
    <div
      className={twMerge(cardWrapperClassName, 'flex flex-col gap-2 text-sm', className)}
      {...props}
    >
      <div className="flex w-full items-center gap-2">
        <div className="flex flex-col items-center justify-center">
          <div className="relative" data-test="tiny-cart-item-image">
            {image}
            {quantity && <Counter value={quantity} data-test="tiny-cart-item-quantity" />}
          </div>
        </div>
        <div className="text-text-light-bg-secondary flex-grow-1">
          <h5
            className={cn(cardTitleClassName, truncateTitle && 'line-clamp-1')}
            data-test="tiny-cart-item-title"
          >
            {title}
          </h5>
          {description.map((item, index) => (
            <div key={`description_item_${index}`} data-test={item.id}>
              {item.content}
            </div>
          ))}
        </div>
        <div className="ml-auto flex-grow-0" data-test="tiny-cart-item-price">
          {price}
        </div>
      </div>
      {footerMessage && (
        <footer className="border-grey-200 text-text-light-bg-secondary flex w-full justify-between border-t border-dashed pt-2 text-sm">
          <span data-test="tiny-cart-item-interval-value">
            <FormattedMessage id={'cart:product:interval'} />:
          </span>
          <span>{footerMessage}</span>
        </footer>
      )}
    </div>
  );
};

export default TinyCartItem;
